export default "__VITE_ASSET__C91H2SOP__"